let routes = [
    {
        path: '/',
        name: '会员卡',
        component: ()=>import('../components/child_router_view'),
        children:[{
            path: '/card-setting',
            name: '基础会员卡',
            component: ()=>import('../components/card/setting'),
        },
        {
            path: '/card-agent',
            name: '经销商卡券',
            component: ()=>import('../components/card/card-list'),
        },
        {
            path: '/card-orders',
            name: '会员卡订单',
            component: ()=>import('../components/card/order'),
        },
        {
            path: '/card-orders-sta',
            name: '会员卡订单统计',
            component: ()=>import('../components/card/order_sta'),
        }],
        meta: {}
    }
];

export default routes;


// WEBPACK FOOTER //
// ./src/router/membership.js